import { ComboboxClearButton, TextInput, TextInputProps } from "@mantine/core"
import { IconSearch } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"

interface Props extends TextInputProps {}

export function SearchTextInput(props: Props) {
  const { t } = useTranslation("app_server")
  return (
    <TextInput
      key={"search-input"}
      label={t("Search")}
      placeholder={t("Search")}
      leftSection={<IconSearch size={15} />}
      rightSection={
        <ComboboxClearButton
          onClear={() =>
            props.onChange && props.onChange({ target: { value: "" } } as any)
          }
        />
      }
      {...props}
    />
  )
}
